import { Component, inject, Input, OnInit } from '@angular/core';
import { CoreModule, dateAfterControlValidator, dateTodayOrAfterValidator, FormComponent, OffersType } from '@toevla-webapplications/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BookingService } from '../../../../../../services/booking/booking.service';

@Component({
    selector: 'ivva-booking-info',
    templateUrl: './booking-info.component.html',
    styleUrls: ['./booking-info.component.scss'],
    imports: [ReactiveFormsModule, CoreModule, TranslateModule]
})
export class BookingInfoComponent extends FormComponent implements OnInit {
	@Input()
	type: OffersType;

	hourOptions: string[];

	readonly OffersType = OffersType;

	protected readonly MAX_CHARS_INFO = 200;

	private readonly bookingService = inject(BookingService);
	private readonly fb = inject(FormBuilder);

	get confirmSocialError(): boolean {
		return this.showErrors && !!this.form?.get('confirmSocial')?.errors;
	}

	get confirmStandardError(): boolean {
		return this.showErrors && !!this.form?.get('confirmStandard')?.errors;
	}

	ngOnInit() {
		this.hourOptions = this.generateHourOptions();
		this.form = this.getForm();
	}

	private generateHourOptions(): string[] {
		const list = [];

		for (let hour = 0; hour < 24; hour++) {
			const h = hour < 10 ? '0' + hour : hour;
			list.push(`${h}:00`);
			list.push(`${h}:30`);
		}

		return list;
	}

	private getForm() {
		const data = this.bookingService.getCurrentBooking();

		const group: FormGroup<any> = this.fb.group({
			arrivalDate: [data.arrivalDate, [Validators.required, dateTodayOrAfterValidator]],
			arrivalHour: [data.arrivalHour],
			extraInfo: [data.extraInfo, Validators.maxLength(this.MAX_CHARS_INFO)],
			confirmSocial: [data.confirmSocial || false, Validators.requiredTrue],
			confirmStandard: [data.confirmStandard || false, Validators.requiredTrue],
		});

		if (this.type === OffersType.ACCOMMODATION) {
			group.addControl(
				'departureDate',
				this.fb.control(data.departureDate, [Validators.required, dateTodayOrAfterValidator, dateAfterControlValidator(group.get('arrivalDate') as any, true, true)])
			);
			this.controlShouldTriggerValidation('arrivalDate', 'departureDate', group);
		}

		return group;
	}
}
